module.exports = __webpack_public_path__ + "img/app3.fb398abf.png";